import React, { Component } from 'react';
import '../../components/css/popupstyle.css';
import $ from 'jquery';
import exportIcon from '../../components/css/dark/img/theme-images/export.svg';
import { debug } from 'util';
import Pagination from "react-js-pagination";

class ReportPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userdata: JSON.parse(localStorage.getItem('user')),
            mainAPIresult: [],
            header: this.props.text,
            APICalled: false,
            tabselected: 'Active',
            error: '',
            activePage: 1

        };
        this.ExportReps = this.ExportReps.bind(this);
    }

    handlePageChange = (pageNumber) => {
        this.setState({ activePage: pageNumber });
        setTimeout(function () {
            // add class on scroll condition
            (function ($) {
                $.fn.hasScrollBar = function () {
                    return this.get(0).scrollHeight > this.height();
                }
            })($);
            if ($('.max-height').hasScrollBar()) {
                $('.table-container').addClass('active-scroll');
            } else {
                $('.table-container').removeClass('active-scroll');
            }
        }, 2000);
    }
    handletab = e => {       
        try {
            this.setState({ tabselected: e.currentTarget.getAttribute("data-id"), activePage: 1 });
            setTimeout(function () {
                // add class on scroll condition
                (function ($) {
                    $.fn.hasScrollBar = function () {
                        return this.get(0).scrollHeight > this.height();
                    }
                })($);
                if ($('.max-height').hasScrollBar()) {
                    $('.table-container').addClass('active-scroll');
                } else {
                    $('.table-container').removeClass('active-scroll');
                }
            }, 2000);
        }
        catch (error) {
            this.setState({ error: 'Something went wrong. Please try later.' });
        }
    }
    GetRepsDetail() {
        try {
            fetch('https://cnd.23byt.es/ws/Reps?wname=' + this.state.userdata.wholesaler)
                .then(response => response.json())
                .then(data => {
                    this.setState({ APICalled: true });
                    if (data != null && data.length > 0)
                      this.setState({ mainAPIresult: data });
                });
        }
        catch (error) {
        }
    }
    GetRepsDetailWithOutCnd() {
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
        try {           
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
                body: JSON.stringify({ 'Prefix': '', 'WhName': this.state.userdata.wholesaler, 'wholesaler_Id': this.state.userdata.wholesaler_Id })
            };
            return fetch(`/api/ws/repsNew`, requestOptions)
                .then(response => response.json())
                .then(data => {
                    setTimeout(() => {
                        $('.popup').addClass('mfp-ready');
                        $('.popup').addClass('mfp-bg');
                        $('.popup').addClass('mfp-with-anim');
                    }, 5);
                    this.setState({ APICalled: true });
                    if (data != null && data.length > 0)
                        this.setState({ mainAPIresult: data });
                });
        }
        catch (error) {
        }
    }
    componentDidMount() {
        this.GetRepsDetailWithOutCnd()
        setTimeout(function () {
            $('.pagination li:first-child').text('First');
            $('.pagination li:last-child').text('Last');

            // add class on scroll condition
            (function ($) {
                $.fn.hasScrollBar = function () {
                    return this.get(0).scrollHeight > this.height();
                }
            })($);
            if ($('.max-height').hasScrollBar()) {
                $('.table-container').addClass('active-scroll');
            }
        }, 20000);
    }

    ExportReps(e) {
        try {
            let Origin_Location = window.location.protocol + "//" + window.location.host;
            window.open(
                Origin_Location + '/report/exportreps1?&objectuid=' + this.state.userdata.id,
                '_blank'
            );
            e.preventDefault();
        }
        catch (error) { }
    }


    render() {
        let len = 0;
        try {
            len = JSON.parse(JSON.parse(JSON.stringify(this.state.mainAPIresult[0]["activeJson"]))).length + JSON.parse(JSON.parse(JSON.stringify(this.state.mainAPIresult[0]["inActiveJson"]))).length;
        }
        catch (error) {
            len = 0;
        }
        if (len > 0) {

            const userlistobj = this.state.tabselected == "Active" ?JSON.parse( JSON.parse(JSON.stringify(this.state.mainAPIresult[0]["activeJson"]))) : JSON.parse( JSON.parse(JSON.stringify(this.state.mainAPIresult[0]["inActiveJson"])))
            return (
                <div className='popup mfp-zoom-in'>
                    <div className='popup_inner rep'>
                        <div className='popup_scroll'>

                            <h1>{this.state.header}<button onClick={this.props.closePopup}></button></h1>

                            <div className="tab-section">
                                <a href="javascript:void('0')" className="rep-download custom-tooltip" targe="_self"><img onClick={this.ExportReps} src={exportIcon} className="export_icon" alt="Download Icon" /><span className="hover-tooltip">Download report</span></a>
                                <div className="tab">
                                    <a href="javascript:;" className={this.state.tabselected == "Active" ? 'tab-link link1 active' : 'tab-link link1'} onClick={this.handletab} data-id="Active">Active</a>
                                    <a href="javascript:;" className={this.state.tabselected == "Inactive" ? 'tab-link link2 active' : 'tab-link link2'} onClick={this.handletab} data-id="Inactive">Inactive</a>
                                </div>
                                <div className="tab1">

                                    <h3> {this.state.tabselected == "Active" ? 'Total Active Reps :' + userlistobj.length : 'Total Inactive Reps :' + userlistobj.length}</h3>

                                    <span>Reps with {this.state.tabselected == "Active" ? 'greater' : 'less'} than 1 claim in last 30 days</span>

                                    <div className="table-container">
                                        <div className="flex-table header">
                                            <div className="flex-row first">Name</div>
                                            <div className="flex-row second">E-mail</div>
                                            <div className="flex-row third">Assigned Group</div>
                                            <div className="flex-row fourth">Commission</div>
                                        </div>
                                        <div className="table_body" id="inactive_reps">
                                            <div className="max-height">
                                                {

                                                    (userlistobj.length > 6 ?  JSON.parse(JSON.stringify( userlistobj)).splice((this.state.activePage - 1) * 6, 6) : userlistobj).map((item, index) => {

                                                        return <div className="flex-table" key={"Active" + index} ><div className="flex-row first">{item.DisName}</div><div className="flex-row second">{item.DisEmail}</div>
                                                            <div className="flex-row third">
                                                                {
                                                                    item.GroupList.map((gpitem, _index) => {
                                                                        return <div key={"ActiveGroup" + _index} >{gpitem.Group.split(' ')[0]}</div>
                                                                    })
                                                                }
                                                            </div>

                                                            <div className="flex-row fourth">
                                                                {
                                                                    item.GroupList.map((gpitem, _index) => {
                                                                        return <div key={"sdbsbdsbGroup" + _index} >{gpitem.Group.split('(')[1].replace(')', '')}</div>
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    })
                                                       
                                                }
                                            </div>
                                        </div>
                                        <Pagination
                                            activePage={this.state.activePage}
                                            itemsCountPerPage={6}
                                            totalItemsCount={userlistobj.length}
                                            pageRangeDisplayed={5}
                                            onChange={this.handlePageChange.bind(this)}
                                        />

                                    </div>

                                </div>
                                {this.state.error &&
                                    <div className={'alert alert-danger tab-alert wh'}>{this.state.error}</div>
                                }
                            </div>

                        </div>
                    </div>
                </div>
            );
        }
        else {
                          return (
                    <div className='popup mfp-zoom-in activeInactiveReps'>
                        <div className='popup_inner rep'>
                            <div className='popup_scroll'>

                                <h1>{this.state.header}<button onClick={this.props.closePopup}>X</button></h1>
                                {

                                    this.state.APICalled == false ? <div className="WhCommission">
                                    <div className="theme-loader repLoader"></div>
                                    <div className="tab-section please-wait"><h3>Please wait...</h3></div>
                                    </div> : <div className="tab1">

                                            <span className="no-row-found">No Reps Found</span>
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                );
            
            
        }
    }
}

export default ReportPopup;